module.exports = __webpack_public_path__ + "img/Kaite.832849a2.jpg";